import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont
} from "assets/jss/material-dashboard-react.jsx";
import tooltipStyle from "assets/jss/material-dashboard-react/tooltipStyle.jsx";

const tableStyle = theme => ({
  ...tooltipStyle,
  warningTableHeader: {
    color: warningColor
  },
  primaryTableHeader: {
    color: primaryColor
  },
  dangerTableHeader: {
    color: dangerColor
  },
  successTableHeader: {
    color: successColor
  },
  infoTableHeader: {
    color: infoColor
  },
  roseTableHeader: {
    color: roseColor
  },
  grayTableHeader: {
    color: grayColor
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse"
    // tableLayout: "auto"
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    fontSize: "1em",
    textTransform: "capitalize"
  },
  emailTableHeadCell: {
    color: "inherit",
    ...defaultFont,
    fontSize: "1em",
    textTransform: "capitalize",
    textAlign: "left",
    paddingLeft: "15px"
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    borderBottom: "1px solid #f6f6f6",
    verticalAlign: "middle"
  },
  emailTableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    borderBottom: "1px solid #f6f6f6",
    verticalAlign: "middle",
    textAlign: "left",
    paddingLeft: "15px"
  },
  tableRow: {
    ...defaultFont,
    textAlign: "center",
    verticalAlign: "middle",
    wordWrap: "break-word"
  },
  tableRowLeft: {
    ...defaultFont,
    textAlign: "center",
    verticalAlign: "middle"
  },
  tableResponsive: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    wordWrap: "break-word",
    overflowX: "auto"
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  dialogControl: {
    width: "100%"
  },
  tableContainer: {
    overflowX: "scroll"
  }
});

export default tableStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/components/tableStyle.jsx